import { Button, Modal } from 'react-bootstrap';

interface IProps {
  content: string;
  onClose: () => void;
}

const ViewConsentModal = ({ content, onClose }: IProps) => {
  return (
    <Modal show onHide={onClose} size='xl' scrollable>
      <Modal.Header closeButton>
        <Modal.Title as='h5'>View Consent</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{ __html: content }} className='consent-content' />
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' className='m-0 rounded-pill' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewConsentModal;
